// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".ReloginDialog-module__dialogBackdrop--ETPHB{z-index:900}.ReloginDialog-module__dialogContent--NZYpE{width:100%;height:100%;overflow:hidden}.ReloginDialog-module__dialogHeader--himta{display:none}.ReloginDialog-module__wrap--leHpd{height:45rem;width:33.333rem}.ReloginDialog-module__iframe--DNYst{overflow:hidden;margin:2rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogBackdrop": "ReloginDialog-module__dialogBackdrop--ETPHB",
	"dialogContent": "ReloginDialog-module__dialogContent--NZYpE",
	"dialogHeader": "ReloginDialog-module__dialogHeader--himta",
	"wrap": "ReloginDialog-module__wrap--leHpd",
	"iframe": "ReloginDialog-module__iframe--DNYst"
};
export default ___CSS_LOADER_EXPORT___;
